import React, { useEffect, useState } from "react";
import { Card } from "reactstrap";
import { Table, Button, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getSystemTransactionData,
  downloadReport,
} from "containers/Transactions/action";
import "./Transaction.css";
import format from "number-formatter";
import moment from "moment";
import { DateRange } from "components";
import TransactionStatus from "components/TransactionStatus/TransactionStatus";
import { redirectDashboard } from "routes/RedirectRoutes";
import { useTheme } from "context/themeContext";
import DOMPurify from "dompurify";
const Transactions = () => {
  const dispatch = useDispatch();
  const { colorTheme, logoUrl, whiteLabelName } = useTheme();

  const [start, setStart] = useState(
    moment()
      .startOf("month")
      .format("YYYY-MM-DD")
  );
  const [end, setEnd] = useState(moment().format("YYYY-MM-DD"));
  const [userEmail, setUserEmail] = useState("");
  const [otp, setOtp] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [objRef, setObjRef] = useState({});
  const [page, setPage] = useState(0);

  const transactions = useSelector(
    (state) => state.systemTransaction?.transactions
  );
  const transactionPages = useSelector(
    (state) => state.systemTransaction?.transactionPages
  );
  const loading = useSelector((state) => state.systemTransaction?.loading);

  useEffect(() => {
    const credentials = JSON.parse(localStorage.getItem("credentials") || "{}");
    setOtp(credentials.token || "");
    setUserEmail(credentials.email || "");

    const onOk = () => {
      dispatch(
        getSystemTransactionData(
          credentials.whiteLabel,
          credentials.token,
          credentials.email,
          start,
          end,
          0,
          10
        )
      );
    };

    onOk();
  }, []);

  const onOk = () => {
    dispatch(
      getSystemTransactionData(
        whiteLabelName,
        otp,
        userEmail,
        start,
        end,
        0,
        10
      )
    );
  };

  const handleTableChange = (pagination) => {
    const currentPage = pagination.current - 1;
    setPage(currentPage);
    dispatch(
      getSystemTransactionData(
        whiteLabelName,
        otp,
        userEmail,
        start,
        end,
        currentPage,
        pagination.pageSize
      )
    );
  };

  const handleDownload = () => {
    dispatch(downloadReport(userEmail, whiteLabelName, otp, start, end));
  };

  const getObjectRef = (transactionId) => {
    setObjRef({ transactionId });
  };

  const columns = [
    {
      title: "Date & Time",
      dataIndex: "dateAndTime",
      key: "dateAndTime",
      render: (_dateandtime, original) => (
        <>{moment(original.transactionDate).format("LLLL")}</>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => (
        <strong>
          <span>&#8358;</span>
          {format("#,##0.####", amount)}
        </strong>
      ),
    },
    {
      title: "Customer Phone",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Travel Route",
      dataIndex: "route",
      key: "route",
    },
    
    {
      title: "",
      key: "x",
      width: "130px",
      render: (_text, original) => (
        <Button
          type="primary"
          className="mr-s"
          style={{ background: colorTheme, border: "none" }}
          onClick={() => {
            getObjectRef(original.transactionId);
            setIsModalOpen(true);
          }}
        >
          View More
        </Button>
      ),
    },
  ];

  return (
    <div className="main-section">
       <div className="topBar">
                   <img
                     src={DOMPurify.sanitize(logoUrl)}
                     alt={`${whiteLabelName} logo`}
                     style={{
                       width: "80px",
                       height: "auto",
                       objectFit: "fit",
                       maxHeight: "80px",
                     }}
                   />
                   <div
                     onClick={redirectDashboard}
                     style={{ color: colorTheme, cursor: "pointer" }}
                   >
                     Go Home
                   </div>
            </div>

      <div className="dashboard_header_">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h4 className="header_title2" style={{ color: colorTheme }}>
            Transactions
          </h4>
        </div>
        <div style={{ display: "flex" }}>
          <button type="button" className="btn" onClick={redirectDashboard}>
            <span className="login-form__bold-text">Back</span>
          </button>
        </div>
      </div>

      <br />
      <br />

      <div className="filter_button_container">
        <div className="firstContainer" style={{ marginRight: 10 }}>
          <DateRange
            getStartDate={(val) => setStart(val)}
            getEndDate={(val) => setEnd(val)}
          />
        </div>
        <div className="btnTransCont">
          <Button
            onClick={onOk}
            type="primary"
            style={{ background: colorTheme, border: "none" }}
          >
            Search Transactions
          </Button>
          <Button
            onClick={handleDownload}
            type="primary"
            style={{
              marginLeft: 10,
              background: colorTheme,
              border: "none",
            }}
          >
            Download Report
          </Button>
        </div>
      </div>

      <br />

      <Card className="login-form__card">
        <div className="transaction_table_container">
          <Table
            rowKey="id"
            dataSource={transactions?.payload}
            columns={columns}
            loading={loading}
            onChange={handleTableChange}
            pagination={{
              total: transactionPages?.payload?.size || 0,
              current: page + 1,
              pageSize: 10,
              onChange: (pg, pageSize) =>
                handleTableChange({ current: pg, pageSize }),
            }}
          />
        </div>
      </Card>

      <Modal
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={false}
      >
        <TransactionStatus data={objRef} />
      </Modal>
    </div>
  );
};

export default Transactions;
